import * as React from 'react';
import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {
  TitleMedium,
  SubTitleMedium,
  SubTitleExtraSmall,
  TEXT_COLORS,
} from '@spaced-out/ui-design-system/lib/components/Text';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import css from './statistics-cards.css';


interface StatisticsCardsProps {
  statistics: {
    total: number;
    missing: number;
    present: number;
    coverage: string;
    topDirectories: [string, number][];
  };
  filteredTotal: number;
  filteredMissing: number;
  filteredPresent: number;
  isFiltered: boolean;
}

export const StatisticsCards: React.FC<StatisticsCardsProps> = ({
  statistics,
  filteredTotal,
  filteredMissing,
  filteredPresent,
  isFiltered,
}) => {
  const {t} = useLabelTranslation();

  return (
    <div className={css.statisticsGrid}>
      <div className={css.statCard}>
        <Icon name="tags" size="large" color={TEXT_COLORS.primary} />
        <div className={css.statContent}>
          <div className={css.statNumbers}>
            <TitleMedium>{statistics.total}</TitleMedium>
            {isFiltered && (
              <SubTitleMedium color="information">
                ({filteredTotal})
              </SubTitleMedium>
            )}
          </div>
          <SubTitleExtraSmall color="secondary">
            {t('Total_Labels', 'Total Labels')}
          </SubTitleExtraSmall>
        </div>
      </div>

      <div className={css.statCard}>
        <Icon name="circle-xmark" size="large" color={TEXT_COLORS.danger} />
        <div className={css.statContent}>
          <div className={css.statNumbers}>
            <TitleMedium>{statistics.missing}</TitleMedium>
            {isFiltered && (
              <SubTitleMedium color="information">
                ({filteredMissing})
              </SubTitleMedium>
            )}
          </div>
          <SubTitleExtraSmall color="secondary">
            {t('Missing_in_enjson', 'Missing in en.json')}
          </SubTitleExtraSmall>
        </div>
      </div>

      <div className={css.statCard}>
        <Icon name="circle-check" size="large" color={TEXT_COLORS.success} />
        <div className={css.statContent}>
          <div className={css.statNumbers}>
            <TitleMedium>{statistics.present}</TitleMedium>
            {isFiltered && (
              <SubTitleMedium color="information">
                ({filteredPresent})
              </SubTitleMedium>
            )}
          </div>
          <SubTitleExtraSmall color="secondary">
            {t('Present_in_enjson', 'Present in en.json')}
          </SubTitleExtraSmall>
        </div>
      </div>
    </div>
  );
};
